<template>
  <div>
    <p
      class="legalText"
      v-html="$t('Web.Registration.Legal.Text', [privacyLink, termsAndConditionsLink])"
    ></p>
  </div>
</template>

<script>
export default {
  name: 'LegalDisclaimer',
  computed: {
    privacyLink() {
      return `<a href="#/termsandconditions">${this.$t('Web.Profile.Buttons.Conditions')}</a>`;
    },
    termsAndConditionsLink() {
      return `<a href="#/privacyagreement">${this.$t('Web.Profile.Buttons.Privacy')}</a>`;
    }
  }
};
</script>

<style lang="scss" scoped>
.legalText {
  @include textSmall;
  color: $bluey-grey;
  padding: 0 16px;
}
</style>
